import Uslovi from "../view/screens/Uslovi/Uslovi";

export default function () {
    return <Uslovi />;
}
